import type { PayloadAction } from "@reduxjs/toolkit";

import { createAppSlice } from "../app/createAppSlice";
import type { ArtesianDataSeriesType } from "../features/artesian/artesianDataTypes";

export interface SelectedRow extends ArtesianDataSeriesType {
  selectedType?: boolean;
  isError?: string;
  TimeTransform?: string;
};
interface SelectedRowsState {
  selectedRows: SelectedRow[];
}

const initialState: SelectedRowsState = {
  selectedRows: [],
};

const selectedRowsSlice = createAppSlice({
  name: "selectedRows",
  initialState,
  reducers: {
    addSelectedRow: (state, action: PayloadAction<SelectedRow>) => {
      state.selectedRows.push(action.payload);
    },
    addSelectedRows: (state, action: PayloadAction<SelectedRow[]>) => {
      state.selectedRows = [...state.selectedRows, ...action.payload];
    },
    removeSelectedRow: (state, action: PayloadAction<number>) => {
      state.selectedRows = state.selectedRows.filter(row => row.MarketDataId !== action.payload);
    },
    clearSelectedRows: state => {
      state.selectedRows = [];
    },
  },
  selectors: {
    getSelectedRows: s => s.selectedRows,
  },
});

export const { addSelectedRow, removeSelectedRow, addSelectedRows, clearSelectedRows } = selectedRowsSlice.actions;
export const { getSelectedRows } = selectedRowsSlice.selectors;
export default selectedRowsSlice.reducer;
